// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const dewpider: PokeData = {
  "id": 751,
  "name": "dewpider",
  "height": 3,
  "weight": 40,
  "base_experience": 54,
  "types": [
    PokeType.WATER,
    PokeType.BUG
  ],
  "api_moves": [
    "headbutt",
    "bite",
    "water-gun",
    "bubble-beam",
    "leech-life",
    "bubble",
    "spider-web",
    "crunch",
    "mirror-coat",
    "water-sport",
    "aqua-ring",
    "bug-bite",
    "soak",
    "entrainment",
    "infestation",
    "lunge",
    "liquidation"
  ],
  "moves": [
    "headbutt",
    "bite",
    "bubble-beam",
    "bubble",
    "crunch",
    "bug-bite",
    "lunge",
    "liquidation",
    "heal-order",
    "leech-steal",
    "pin-rush",
    "bug-buzz",
    "pounce"
  ],
  "evolution_chain": {
    "id": 387,
    "item": null,
    "species": [
      {
        "name": "dewpider",
        "order": 751,
        "types": [
          PokeType.WATER,
          PokeType.BUG
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "araquanid",
        "order": 752,
        "types": [
          PokeType.WATER,
          PokeType.BUG
        ],
        "evolves_from_species_id": 751,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 22,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 50,
    "speed": 27,
    "ability_power": 40
  },
  "stat_changes": [],
  "catch_rate": 200,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
